export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";